<template>
  <section
    class="section-intro"
    style="float: left;
      margin-top: 12%;
      margin-left: 10%;"
  >
    <el-table
      ref="singleTable"
      :data="tableData"
      :row-class-name="tableRowClassName"
      highlight-current-row
      style="width: 100% "
      :default-sort="{prop: 'createTime', order: 'ascending'}"
    >
      <!-- <el-table-column type="index" width="50"></el-table-column> -->
      <el-table-column property="index" label="報名序號" width="50"></el-table-column>
      <el-table-column property="activity" label="報名活動" sortable width="120"></el-table-column>
      <el-table-column property="signedDate" label="報名日期" width="120"></el-table-column>
      <el-table-column property="signedTime" label="報名時間"></el-table-column>
      <el-table-column property="createTime" label="建立時間" width="170" sortable></el-table-column>
      <el-table-column property="signedAmount" label="報名人數"></el-table-column>
      <el-table-column property="name" label="姓名" width="120"></el-table-column>
      <el-table-column property="phone" label="電話"></el-table-column>
      <el-table-column property="email" label="信箱"></el-table-column>
    </el-table>
  </section>
</template>

<style scoped>
.section-intro  >>> .el-table__row.rowIsDelete {
  display: none;
}
</style>
<script >
export default {
  data() {
    return {
      tableData: [],
      currentRow: null
    };
  },
  created() {
    this.tableData = [];
    const p = new Promise((resolve, reject) => {
      let data = [];
      const readActivitysSign = firebaseDB.ref("signedUp/activitys");
      readActivitysSign
        .orderByChild("createTime")
        .on("value", function(snapshot) {
          snapshot.forEach(function(childSnapshot) {
            let len = 1
            Object.keys(childSnapshot.val()).forEach((index, value) => {
              let tmpSnapshot = childSnapshot.val()[index]
              tmpSnapshot["index"] = len
              tmpSnapshot["activity"] = childSnapshot.key
              len += 1
              data.push(tmpSnapshot)
            })
          });
          resolve(data);
        });
    }).then(data => {
      this.tableData = data
    });
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (row.isDelete == true) {
        return "rowIsDelete";
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Manager.vue